(function () {
  'use strict';

  angular
    .module('events.vehicles.guests')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('events.vehicles.guests.list', {
        url: '?q&p',
        params: {
          q: {
            value: '',
            squash: true
          },
          p: {
            value: '1',
            squash: true
          }
        },
        reloadOnSearch: false,
        templateUrl: 'events/vehicles/guests/list/list.tpl.html',
        controller: 'GuestsListCtrl',
        controllerAs: 'vm'
      })
    ;
  }
}());
